import { EnterprisePaths } from 'src/components/AppRoutes/Enterprise/EnterprisePathsDictionary';

const base = EnterprisePaths.mealCredits;
export const MealCreditPaths = {
  base,
  create: `${base}/create`,
  mealCreditId: `${base}/:mealCreditId`,
  edit: `${base}/:mealCreditId/edit`,
  details: `${base}/:mealCreditId/details`,
};
